import { type CapturePersistencePolicy } from '../ports/persistence-policy';
import { getConfiguredPersistencePolicy } from './configuration';

// Late-binding delegate over the configured async persistence policy: resolves
// the current resolver per call, and unconfigured resolves `false` (legacy).
// Coalescing, fallback, the pin log and the pinned mode belong to the
// pipeline-mode coordinator, not here.
export const capturePersistencePolicy: CapturePersistencePolicy = {
  resolveLedgerEnabled: () => getConfiguredPersistencePolicy().resolveLedgerEnabled(),
};
